// import { EnvInterface } from "../app/common/interfaces/global-interfaces";

// export const environment: EnvInterface = {
//   production: true,
//   INDEXED_DB_VERSION: 1,
//   // AUTH_SERVER_URL: '',
//   // SERVER_URL: '',
//   AUTH_SERVER_URL: 'https://wemis.msd.go.tz',
//   SERVER_URL: 'https://wemis.msd.go.tz',
//   MEDIA_SERVER_URL: 'https://wemis.msd.go.tz/wemis_media',
//   ALLOW_PERMISSIONS: true,

//   CLIENT_ID: 'd39c4ce72e3b01cdfefa',
//   CLIENT_SECRET: '7fc1229b3c40bdf5c4fe35798b9594ef6911d30d',
//   PLATFORM_ID: 'LfVZDEmF',
//   GRANT_TYPE: 'password',
//   SESSION_TIMEOUT: 900000 // time out session in 15 minutes,
// };

import { EnvInterface } from "../app/common/interfaces/global-interfaces";

export const environment: EnvInterface = {
  production: false,
  INDEXED_DB_VERSION: 1,
  AUTH_SERVER_URL: 'https://warehouse.all.tz/',
  MEDIA_SERVER_URL: 'https://warehouse.all.tz/wemis_media',
  SERVER_URL: 'https://warehouse.all.tz/',
  // AUTH_SERVER_URL: 'http://localhost:8000',
  // SERVER_URL: 'http://localhost:8000',
  ALLOW_PERMISSIONS: true,

  CLIENT_ID: '474e4d27c914a90fb2ed',
  CLIENT_SECRET: '0f0f66df21014f0aad24ce5d3788963c7ba37b0d',
  PLATFORM_ID: 'LfVZDEmF',
  GRANT_TYPE: 'password',
  SESSION_TIMEOUT: 900000 // time out session in 15 minutes,
};
